import { SafeUrl } from '@angular/platform-browser';
import { WorkflowItem } from './workflow-item.model';
import { getFileNameFromPath } from 'app/_utils/file-path.utils';
import DateTimeUtils from 'app/_utils/datetime.utils';

export class WorkerCompetencyWorkflowItem extends WorkflowItem {
  workerUserCompetencySiteOwnerId: number;
  siteOwnerSkylarkUserId: number;
  workerSkylarkUserId: number;
  certificateStatus: string;
  competencyTypeId: string;
  competencyType: string;
  competencyApprovalReason: string;
  expiryDate: Date;
  files: { fileName: string, safeUrl?: SafeUrl }[];
  workerName: string;
  competencyCategory: string;

  public deserialize(input: any): this {
    super.deserialize(input);

    this.workerUserCompetencySiteOwnerId = input.workerCompetencyId;
    this.siteOwnerSkylarkUserId = input.siteOwnerSkylarkUserId;
    this.workerSkylarkUserId = input.skylarkUserId;
    this.expiryDate = this.parseExpiryDate(input.expiryDate);
    this.certificateStatus = input.status;
    this.files = this.getFiles(input);
    this.lastModifiedDate = this.parseDate(input.approvalLastModifiedDate || input.lastModifiedDate);
    this.competencyTypeId = input.competencyTypeId;
    this.competencyType = input.competencyTypeName || '';
    this.competencyCategory = input.competencyType;
    this.competencyApprovalReason = input.competencyApprovalReason;
    // This service records the rejection reason under its own name, so the base class's read of
    // input.comments finds nothing to normalise.
    this.rejectionReason = this.isRejected() ? input.competencyApprovalReason : null;
    this.workerName = input.fullName || '';

    this.details = this.competencyType;
    return this;
  }

  private getFiles(competency: any): { fileName: string, safeUrl?: SafeUrl }[] {
    return competency.supportingDocumentation
      ? [{ fileName: getFileNameFromPath(competency.supportingDocumentation) }]
      : [];
  }

  private parseExpiryDate(value: any): Date {
    if (!value) {
      return null;
    }

    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return DateTimeUtils.timelessDateStrAsUTCDate(value);
    }

    return this.parseDate(value);
  }

  public getTaskDetails(): string {
    return this.workerName ? `Worker ${this.workerName} - certificate needs approval` : 'Worker certificate needs approval';
  }
};
